import React from "react";
import VideoPlayer from "./VideoPlayer";

import Header from "./Header";
import Footer from "./Footer";
import "video.js/dist/video-js.css";
import "../styles/CollectiveReel.scss";

class Reel2020 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: [
        {
          autoplay: false,
          controls: true,
          poster: "http://estelleleeds.com/videos/SIZZLE_REVISED_FINAL.jpg",
          sources: [
            {
              src: "http://estelleleeds.com/videos/SIZZLE_REVISED_FINAL.mp4",
              type: "video/mp4",
            },
          ],
        },
      ],
    };
  }
  render() {
    return (
      <div>
        <Header />
        <div className="container">
          <div className="contact-reels">
            <h1 className="serif-italic-font">2020 Reel</h1>
            <div className="data-vjs-player">
              <VideoPlayer {...this.state.videos[0]} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Reel2020;
